import { render, staticRenderFns } from "./ReportPaginationComponent.vue?vue&type=template&id=1ffdf621&"
import script from "./ReportPaginationComponent.vue?vue&type=script&lang=js&"
export * from "./ReportPaginationComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportPaginationComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports